/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByDescription } from './Scaffolding';
import {
    TextField,
    Show,
    Create,
    SimpleForm,
    Edit,
    DateField,
    SimpleShowLayout,
    List,
    Datagrid,
    BooleanField,
} from 'react-admin';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { TextInput } from '../lib/wrappers/Inputs';
import { EditToolbar } from '../layout/EditToolbar';

export const PartnerCollegeLabels = {
    pageTitle: 'Partner College',
    Title: 'Code',
};

export const PartnerCollegeList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <List
                {...props}
                title={PartnerCollegeLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField label="Code" source="Title" />
                    <BooleanField source="current" />
                </Datagrid>
            </List>{' '}
        </ReadOnlyContext.Provider>
    );
};

export const PartnerCollegeEdit = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <Edit title={<ShowTitleByDescription />} {...props} redirect="edit">
                <SimpleForm toolbar={<EditToolbar />}>
                    <TextInput source="id" disabled />
                    <TextInput label="Title" source="Title" />
                    <TextInput source="created_at" disabled />
                    <TextInput source="updated_at" disabled />
                </SimpleForm>
            </Edit>
        </ReadOnlyContext.Provider>
    );
};

export const PartnerCollegeCreate = (props) => (
    <Create {...props} redirect="edit">
        <SimpleForm>
            <TextInput source="Title" />
        </SimpleForm>
    </Create>
);

export const PartnerCollegeShow = (props) => (
    <Show title={<ShowTitleByDescription />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField label="Code" source="Title" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);
